import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmationModalComponent, ModalComponent } from "@components/index";
import { ToolReturn } from "@models/tool-return.model";
import { Log } from "ng2-logger";
import { ToolRequestStatus } from "@app/tool/model/enums/tool-request-status.enum";
import { PermissionService } from "@app/authentication/services/permission.service";
import { AuthenticationService } from '@app/authentication/services/authentication.service';
import {ToolReturnTypeEnum} from "@models/enums/tool-return-type.enum";

@Component({
    selector: 'app-pending-tool-returns-modal',
    templateUrl: './pending-tool-returns-modal.component.html',
    styleUrls: ['./pending-tool-returns-modal.component.scss']
})
export class PendingToolReturnsModalComponent implements OnInit {
    _logger = Log.create(PendingToolReturnsModalComponent.name);

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @ViewChild(ConfirmationModalComponent, {static: true}) confirmationModal: ConfirmationModalComponent;

    @Input() label: string;
    @Output()
    closeToolReturn: EventEmitter<any> = new EventEmitter();
    @Input() isConfirmationInProgress;
    public pendingToolReturn = new ToolReturn();

    constructor(private permissionService: PermissionService,
        private authService: AuthenticationService) {
    }

    ngOnInit() {
    }

    open(pendingToolReturn = new ToolReturn()) {
        this.pendingToolReturn = pendingToolReturn;
        this.modal.open();
    }

    close() {
        this.modal.close();
    }

    closeConfirmationModal() {
        this.confirmationModal.close();
    }

    clickCloseToolReturn() {
        this.modal.close();
        this.confirmationModal.open();
    }

    onConfirmOrder(event) {
        this.pendingToolReturn.reason = event;
        this.closeToolReturn.emit(this.pendingToolReturn);
    }

    computeCanRenderClose(pendingToolReturn: ToolReturn) {
        return pendingToolReturn.status === ToolRequestStatus.NEW && this.shouldRenderModifiers();
    }

    shouldRenderModifiers() {
        return this.permissionService.hasHasPermissionForFeature('CREATE_TOOL_RETURNS');
    }

    shouldShowClosedInfo() {
        return this.pendingToolReturn.status === 'Canceled' ||  this.pendingToolReturn.status === 'Closed';
    }

    shouldShowReturnInfo() {
        return (this.pendingToolReturn.type === ToolReturnTypeEnum.LINE || this.pendingToolReturn.type === ToolReturnTypeEnum.MAINTENANCE)
         && this.pendingToolReturn.status !== 'Canceled';
    }
}
